import Cookies from 'universal-cookie'
export const cookies = new Cookies()

export const LOCAL_STORAGE = {
  getItem: (key) => {
    return localStorage.getItem(key)
  },

  setItem: (key, value) => {
    return localStorage.setItem(key, value)
  },

  removeItem: (key) => {
    return localStorage.removeItem(key)
  },
}

export const COOKIE_STOAGE = {
  getItem: (key) => {
    return cookies.get(key)
  },

  setItem: (key, value, options = {}) => {
    if (!options.path) {
      options['path'] = '/'
      // options['HttpOnly'] = true
      // options['secure'] = true
    }
    cookies.set(key, value, options)
  },

  removeItem: (key) => {
    cookies.remove(key, { path: '/' })
  },
}
